<template>
  <form id="forgot-form" role="form" style="display: block;" class="white_bg p-4">
    <div class="row m-0 form_holder p-0">
      <div class="col-12 mb-3 p-0 pb-3 border-bottom">
        <div class="row m-0 align-items-center">
          <div class="col p-0">
            <h4 class="mb-0">Forgot Password</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-0 form_holder p-0">
      <div class="col-12 p-0">
        <div class="form-group">
          <label for="name">Email Address</label>
          <input
            type="email"
            name="email"
            id="email"
            class="form-control"
            placeholder="Email Address"
            v-model="email"
            required
          />
        </div>
        <div class="form-group my-4">
          <div class="text-center pb-3" v-if="message" >{{message}}</div>
          <button class="btn btn-primary w-100" disabled v-if="isSent">
            Email Sent
          </button>
          <button class="btn btn-primary w-100" @click="sendForgot()" v-else>
            Submit
          </button>
        </div>
        <div class="border-bottom mb-4"></div>
        <div class="error_text text-center mb-3" v-if="hasError">{{errorMsg}}</div>
        <div class="form-group">
          <div class="row">
            <div class="col-lg-12">
              <div class="text-center smaller_font">
                Back to <span class="link_colour cursor" @click="goTo('login')">Login</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      email: '',
      message: '',
      hasError: false,
      isSent: false
    }
  },
  methods: {
    ...mapActions(['forgotPassword']),
    goTo (val) {
      this.$emit('goTo', val)
    },
    sendForgot () {
      this.isSent = true
      setTimeout(() => {
        this.isSent = false
      }, 20000)
      this.forgotPassword(this.email)
    }
  }
}
</script>
<style scoped>
label {
  margin-bottom: 0;
}
</style>
